<template lang="html">
  <section class="ctn-patrimonial-landscape">
		<h1>Mon Paysage Patrimonial</h1>
		<div class="subtitle">
			Avant de remplir votre Paysage Patrimonial, merci de prendre connaissance de <a href="#" @click="displayRgpdModal = true" style="text-decoration: underline;">ces informations légales importantes</a>.
		</div>
		<div class="subtitle" v-if="!isAnonymous">
			Complétez votre paysage patrimonial (la version complète nécessite 20 minutes maximum) étape par étape ou librement en naviguant par thématique. Cliquez sur "Sauvegarder" pour enregistrer votre saisie au fur et à mesure. Vous pourrez le reprendre à tout moment en vous reconnectant. La validation de votre paysage patrimonial sera effective une fois l'étape de signature réalisée.
		</div>
		<div class="subtitle" v-else>
			Complétez votre paysage patrimonial (la version complète nécessite 20 minutes maximum) étape par étape ou librement en naviguant par thématique. Cliquez sur "Sauvegarder" pour enregistrer votre saisie au fur et à mesure. Vous pourrez le reprendre à tout moment en vous reconnectant. La validation de votre paysage patrimonial sera effective une fois ce dernier validé et téléchargé.
		</div>
		<patrimonial-landscape :user="user"/>
		<base-modal :show="displayRgpdModal" @close="displayRgpdModal = false" :content="contentModalRgpd" />
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import PatrimonialLandscape from '@/common/components/MyPatrimonialLandscape/PatrimonialLandscape'
import ModalRgpd from '@/common/components/MyPatrimonialLandscape/modal/Rgpd'

export default {
	name: 'my-patrimonial-landscape',
	data () {
		return {
			displayRgpdModal: false,
			contentModalRgpd: ModalRgpd
		}
	},
	components: {
		PatrimonialLandscape
	},
	computed: {
		...mapGetters({
			user: 'user',
			isAnonymous: 'isAnonymous'
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/views/Documents/PatrimonialLandscape/PatrimonialLandscapeUpdate.vue